<div ngbDropdown>
  <button class="btn btn-info btn-dropdown" ngbDropdownToggle>
    {{ title }}
  </button>
  <div ngbDropdownMenu class="dropdownMenu longdropdown">
    <input
      *ngIf="items.length > minItemsToShowSearch"
      type="text"
      placeholder="Search..."
      id="filterfilter"
      class="form-control"
      [(ngModel)]="search"
    />
    <div *ngFor="let item of getItemsFiltered()" class="my-1 mx-1 form-check">
      <input
        type="checkbox"
        class="form-check-input"
        [id]="item[0]"
        [(ngModel)]="item[1]"
        [ngModelOptions]="{ standalone: true }"
      />
      <label class="form-check-label" [for]="item[0]">{{
        item[0] || emptyItemLabel | titlecase
      }}</label>
    </div>
  </div>
</div>
